import { useMemo, useState } from 'react';
import WebhookDeleteModal from 'automation-ui-enrollment/components/eventEnrollment/WebhookDeleteModal';
import WebhookEditPanel from 'automation-ui-enrollment/components/eventEnrollment/WebhookEditPanel';
import WebhookTriggersEmptyState from 'automation-ui-enrollment/components/eventEnrollment/webhooks/WebhookTriggersEmptyState';
import WebhooksForAllObjectsView from 'automation-ui-enrollment/components/eventEnrollment/webhooks/WebhooksForAllObjectsView';
import WebhooksForSameObjectView from 'automation-ui-enrollment/components/eventEnrollment/webhooks/WebhooksForSameObjectView';
import WebhooksForDifferentObjectsView from 'automation-ui-enrollment/components/eventEnrollment/webhooks/WebhooksForDifferentObjectsView';
import WebhookLimitCountFooter from 'automation-ui-enrollment/components/eventEnrollment/webhooks/WebhookLimitCountFooter';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WebhookSelectionView = ({
  webhooks,
  objectTypeId,
  setShowWizard,
  handleWebhookSelect,
  handleWebhookDelete,
  handleWebhookUpdate
}) => {
  const trackEvent = useTrackEvent();
  const [webhookStagedForDeletion, setWebhookStagedForDeletion] = useState(null);
  const [webhookStagedForEdit, setWebhookStagedForEdit] = useState(null);
  const webhooksForObjectTypeId = useMemo(() => objectTypeId ? webhooks.filter(webhook => webhook.objectTypeId === objectTypeId) : webhooks, [webhooks, objectTypeId]);
  const webhooksForDifferentObjects = useMemo(() => webhooks.filter(webhook => webhook.objectTypeId !== objectTypeId), [webhooks, objectTypeId]);
  const hasNoWebhooks = webhooks.length === 0;
  const limitCountFooter = /*#__PURE__*/_jsx(WebhookLimitCountFooter, {
    numWebhooks: webhooks.length,
    onClickCreateWebhook: () => {
      trackEvent(Trackables.WEBHOOK_TRIGGER_MODIFIED, {
        objectTypeId,
        editType: 'CREATE'
      });
      setShowWizard(true);
    }
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [webhookStagedForDeletion && /*#__PURE__*/_jsx(WebhookDeleteModal, {
      objectTypeId: objectTypeId !== null && objectTypeId !== void 0 ? objectTypeId : webhookStagedForDeletion.objectTypeId,
      webhookDefinition: webhookStagedForDeletion,
      onClose: () => setWebhookStagedForDeletion(null),
      handleWebhookDelete: handleWebhookDelete
    }), webhookStagedForEdit && /*#__PURE__*/_jsx(WebhookEditPanel, {
      objectTypeId: objectTypeId !== null && objectTypeId !== void 0 ? objectTypeId : webhookStagedForEdit.objectTypeId,
      webhookDefinition: webhookStagedForEdit,
      onClose: () => setWebhookStagedForEdit(null),
      handleWebhookUpdate: handleWebhookUpdate
    }), hasNoWebhooks ? /*#__PURE__*/_jsx(WebhookTriggersEmptyState, {
      setShowWizard: setShowWizard
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [!objectTypeId && /*#__PURE__*/_jsx(WebhooksForAllObjectsView, {
        footer: limitCountFooter,
        webhooks: webhooksForObjectTypeId,
        setShowWizard: setShowWizard,
        handleWebhookSelect: handleWebhookSelect,
        setWebhookStagedForEdit: setWebhookStagedForEdit,
        setWebhookStagedForDeletion: setWebhookStagedForDeletion
      }), objectTypeId && /*#__PURE__*/_jsx(WebhooksForSameObjectView, {
        footer: limitCountFooter,
        webhooks: webhooksForObjectTypeId,
        objectTypeId: objectTypeId,
        setShowWizard: setShowWizard,
        handleWebhookSelect: handleWebhookSelect,
        setWebhookStagedForEdit: setWebhookStagedForEdit,
        setWebhookStagedForDeletion: setWebhookStagedForDeletion
      }), objectTypeId && webhooksForDifferentObjects.length > 0 && /*#__PURE__*/_jsx(WebhooksForDifferentObjectsView, {
        webhooks: webhooksForDifferentObjects,
        objectTypeId: objectTypeId,
        setWebhookStagedForDeletion: setWebhookStagedForDeletion
      })]
    })]
  });
};
export default WebhookSelectionView;